var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[_c('Header'),_vm._v(" "),_c('Tutorials'),_vm._v(" "),_c('Details')],1)}
var staticRenderFns = []

export { render, staticRenderFns }